import { lightTheme } from '@/customTheme'

function LightingIcon({ size = 24, fill = lightTheme.colors.blackGray }: { size?: number; fill?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(0.06 0.14)">
        <path
          fill={fill}
          d="M13.44 22.284c.366.001.598.379.351.648a2.438 2.438 0 0 1-3.594-.007c-.245-.27-.011-.646.354-.646l2.89.005Zm.646-2.879a.966.966 0 0 1 0 1.932H9.904a.966.966 0 0 1 0-1.932h4.182ZM12.03 5.582c2.465-.002 4.532 1.361 5.633 3.22 1.106 1.87 1.267 4.303-.166 6.379l-.118.164c-.09.116-.186.252-.288.402-.31.459-.56.827-.768 1.111-.207.282-.411.533-.644.735-.495.429-.95.67-1.582.84-.537.143-1.154.135-2.013.135-.88 0-1.51.008-2.048-.135-.642-.172-1.08-.405-1.582-.84-.235-.204-.444-.463-.656-.753-.216-.295-.475-.68-.801-1.16a11.99 11.99 0 0 0-.245-.349 7.93 7.93 0 0 1-.307-.469C3.897 10.65 7.335 5.586 12.03 5.582Zm.002 1.932c-3.421.003-5.585 3.616-3.933 6.347.096.159.166.265.21.325.098.133.194.272.289.412.334.494.57.842.76 1.1.192.263.297.379.363.435.28.244.456.337.815.433.23.061.543.07 1.548.07.98 0 1.284-.009 1.514-.07.349-.094.541-.196.814-.433.067-.058.17-.17.354-.419.18-.246.405-.576.724-1.048.116-.172.234-.34.352-.494l.064-.088c.948-1.373.869-2.985.093-4.296-.782-1.32-2.242-2.275-3.968-2.273ZM3.32 11.162a.966.966 0 0 1 0 1.932H.966a.966.966 0 0 1 0-1.932H3.32Zm19.814 0a.966.966 0 0 1 0 1.932h-2.355a.966.966 0 0 1 0-1.932h2.355ZM20.208 4.385a.966.966 0 0 1 .966 1.673l-2.04 1.176a.966.966 0 1 1-.965-1.672l2.039-1.177ZM2.56 4.731a.966.966 0 0 1 1.32-.353L5.92 5.555a.966.966 0 1 1-.966 1.673L2.914 6.05a.966.966 0 0 1-.353-1.319ZM12.06 0c.533 0 .965.432.965.966V3.32a.966.966 0 0 1-1.931 0V.966c0-.534.432-.966.966-.966Z"
        />
      </g>
    </svg>
  )
}

export default LightingIcon
